import gql from 'graphql-tag';

export const GetRehirePrefillQuery = gql`
  query GetRehirePrefill($contractor_id: ID!, $workspace_id: ID!) {
    getRehirePrefill(contractor_id: $contractor_id, workspace_id: $workspace_id) {
      contractor_workspace_id
      contractor_workspace_name
      hiring_companies {
        id
        name
      }
      placement {
        job_title
        vendor_rate
        pay_frequency
        estimated_hours
        shore_type_id
        work_location_type_id
        work_location_type
        scheduled_offboard_date
      }
      candidate {
        summary
        contact {
          first_name
          last_name
          email_id
          phone_number
          phone_type
          linkedin_url
          skype_id
          work_authorized
          visa_required
          street_address
          city
          state
          zip_code
          country
        }
        skills {
          name
          proficiency_rating
          standout_skill
          verified
        }
        employment_history {
          company_name
          job_title
          start_date
          end_date
          additional_information
        }
        education_history {
          school_name
          degree_name
          start_date
          end_date
          gpa
          additional_information
        }
      }
    }
  }
`;

export const GetCandidateByIdQuery = gql`
  query GetCandidateById($id: ID!) {
    candidateDetails(id: $id) {
      id
      created_on
      additional_information
      status
      contact {
        id
        first_name
        last_name
        linkedin_url
        skype_id
        email_id
        phone_number
        ssn
        street_address
        city
        state
        country
        zip_code
        phone_type
        work_authorized
        visa_required
      }
      job_req {
        job_title {
          name
        }
        alternate_title
      }
      market_rate
      status
      submission_rate
      score
      raw_hirevue_scores {
        codeVueScore
        mspRating
        inSightScore
        plagiarismScore
      }
      summary
      is_shortlisted
      hm_viewed
      job_id
      job_duration
      job_uuid
      rate_frequency {
        id
        name
      }
      candidate_documents {
        id
        document_category {
          id
          category
        }
        document_name
        document_url
      }
      candidate_interview_feedback {
        vote
        id
        interviewer_name
        created_on
      }
      sub_contractor_firm
      earliest_start_date
      interview_availability
      is_prior_contractor
      vendor {
        id
        company_name
      }
      hirevue_link
      created_by {
        first_name
        last_name
      }
      skills {
        name
        proficiency_rating
        standout_skill
        verified
      }
      employment_history {
        id
        company_name
        job_title
        start_date
        end_date
        additional_information
      }
      education_history {
        id
        school_name
        degree_name
        start_date
        end_date
        gpa
        additional_information
      }
      candidate_resume {
        skills {
          skill
          last_used
          total_months
        }
        work_experience {
          title
          start_date
          end_date
          description
          org_name
        }
        educational_qualifications {
          start_date
          end_date
          degree_name
          school_name
          degree_major
          location
          cgpa
        }
        months_of_work_experience
        average_months_per_employer
        summary
      }
      work_location_type_preferences {
        id
        work_location_type_id
        work_location_type_name
      }
      shore_type_preferences {
        id
        shore_type_id
        shore_type_name
      }
      vendor_rate
      clients {
        id
        name
      }
      client_hiring_companies {
        id
        name
        workspace {
          id
          name
        }
      }
      location
      avatarUrl
      estimated_hours
      mark_up_percentage
      approved_workspaces {
        id
        workspace_id
        client_name
      }
      vendor_invited_workspace_ids
    }
  }
`;

export const UpdateCandidateStatus = gql`
  mutation updateCandidateStatus($input: EditCandidate) {
    updateCandidateStatus(input: $input)
  }
`;

export const SubmitCandidate = gql`
  mutation submitCandidate($input: SubmitCandidateInput) {
    submitCandidate(input: $input) {
      message
      result {
        contact_id
      }
      success
    }
  }
`;

export const EditCandidate = gql`
  mutation editCandidate($id: ID!, $input: SubmitCandidateInput) {
    editCandidate(id: $id, input: $input) {
      message
      result {
        contact_id
      }
      success
    }
  }
`;

export const ValidatesNameAndSsn = gql`
  query validatesNameAndSsn($job_id: ID!, $first_name: String, $last_name: String, $ssn: ID, $email_id: String) {
    validatesNameAndSsn(
      job_id: $job_id
      first_name: $first_name
      last_name: $last_name
      ssn: $ssn
      email_id: $email_id
    ) {
      contact_id
      is_valid
    }
  }
`;

export const CandidateActionRejectReasons = gql`
  query actionReasonsForCandidate($rejectReasonType: String) {
    candidateActionReasons(rejectReasonType: $rejectReasonType) {
      reject_reasons {
        id
        reason
      }
    }
  }
`;

export const CandidateActionWithdrawReasons = gql`
  query candidateActionReasons {
    candidateActionReasons {
      withdraw_reasons {
        id
        reason
      }
    }
  }
`;

export const GetCandidateListFilters = gql`
  query GetCandidatesListFiltersV2($input: CandidateListWithFiltersAndSearchTextV2Input) {
    getCandidatesListV2(input: $input) {
      columnFilters {
        col_id
        filters {
          doc_count
          key
        }
      }
    }
  }
`;

export const GetCandidatesListWithFiltersAndSearchTextV2 = gql`
  query GetCandidatesListV2($input: CandidateListWithFiltersAndSearchTextV2Input) {
    getCandidatesListV2(input: $input) {
      candidates {
        contact {
          first_name
          last_name
        }
        vendor {
          id
          company_name
        }
        job_req {
          alternate_title
        }
        created_on
        status
        vendor_rate
        summary
        score
        approved_workspaces {
          id
          name
        }
        vendor_invited_workspace_ids
        raw_hirevue_scores {
          codeVueScore
          mspRating
          inSightScore
          plagiarismScore
        }
        is_shortlisted
        hm_viewed
        id
        job_id
        job_uuid
        candidate_documents {
          document_category {
            id
            category
          }
          document_name
          document_url
          id
        }
        candidate_interview_feedback {
          vote
        }
        sub_contractor_firm
        earliest_start_date
        interview_availability
        is_prior_contractor
        hirevue_link
        job_title
        market_rate
        offer_decision_pending
        vendor_rate
        location
      }
      count
    }
  }
`;

export const GetCandidatesListWithFiltersAndSearchTextV2Export = gql`
  query GetCandidatesListV2Export($input: CandidateListWithFiltersAndSearchTextV2Input) {
    getCandidatesListV2(input: $input) {
      exportUrl
    }
  }
`;

export const CandidateFormRequirement = gql`
  query candidateFormRequirement {
    candidateFormRequirement {
      jobTitle {
        id
        name
      }
      candidateDocumentCategory {
        id
        category
        description
      }
      rateFrequency {
        id
        name
      }
      clients {
        id
        name
      }
      clientHiringCompany {
        id
        workspace {
          id
          name
        }
        name
      }
    }
  }
`;

export const GetDocument = gql`
  query getDocument($document_id: ID) {
    getDocument(document_id: $document_id) {
      document_category {
        id
        category
      }
      document_name
      document_url
    }
  }
`;

export const GetCandidateActivities = gql`
  query getCandidateActivities($input: ActivityInput) {
    getCandidateActivities(input: $input) {
      id
      created_on
      created_by
      created_by_user {
        id
        first_name
        last_name
        profile_url
      }
      updated_on
      last_updated_by
      updated_by_user {
        id
        first_name
        last_name
      }
      entity_id
      entity_type
      type
      candidate {
        contact {
          id
          first_name
          last_name
        }
      }
      metafields {
        comment
        reason_id
        from_status
        to_status
        reason {
          id
          reason
        }
        approved_clients
        rejected_clients
        change_in_approved_clients
        old_approved_clients
        new_approved_clients
        new_ssn
        old_ssn
        change_in_ssn
        new_last_name
        old_last_name
        change_in_name
        change_in_rate
        change_in_rate_frequency
        new_first_name
        old_first_name
        change_in_email
        change_in_summary
        change_in_location
        change_in_skype_id
        change_in_documents
        change_in_linkedin_url
        change_in_phone_number
        change_in_earliest_start_date
        change_in_sub_contractor_firm
        change_in_interview_availability
        change_in_mark_up_percentage
        change_in_submitted_client
        old_submitted_clients
        new_submitted_clients
        change_in_job_title
        old_job_title
        new_job_title
        change_in_candidate_available_locations
        change_in_submitted_hiring_company
        old_submitted_hiring_companies
        new_submitted_hiring_companies
        change_in_work_location_type_preferences
        change_in_shore_type_preferences
        old_shore_type_preferences
        new_shore_type_preferences
        change_in_address
        change_in_work_authorized
        old_work_authorized
        new_work_authorized
        change_in_visa_required
        old_visa_required
        new_visa_required
        workspace_name
        job_number
        interview_type
        interview_start
        subscription_tier
        previous_subscription_tier
        score
        job_title
      }
    }
  }
`;

export const InviteCandidatesToWorkspacesMutation = gql`
  mutation inviteCandidatesToWorkspaces($input: InviteCandidatesToWorkspacesInput) {
    inviteCandidatesToWorkspaces(input: $input)
  }
`;

export const RejectCandidatesFromWorkspacesMutation = gql`
  mutation rejectCandidatesFromWorkspaces($input: RejectCandidatesFromWorkspacesInput) {
    rejectCandidatesFromWorkspaces(input: $input)
  }
`;

export const GetAllPersons = gql`
  query getAllPersons($input: CandidateListWithFiltersAndSearchTextV2Input) {
    getAllPersons(input: $input) {
      count
      persons {
        id
        person_id
        first_name
        last_name
        email_id
        ssn
        phone_number
        address
      }
    }
  }
`;

export const GetAllPersonsExport = gql`
  query getAllPersonsExport($input: CandidateListWithFiltersAndSearchTextV2Input) {
    getAllPersons(input: $input) {
      exportUrl
    }
  }
`;

export const LinkContactToNewPerson = gql`
  mutation linkContactToDifferentPerson($contact_id: ID!, $new_person_id: ID!) {
    linkContactToDifferentPerson(contact_id: $contact_id, new_person_id: $new_person_id)
  }
`;

export const UnlinkContactFromPerson = gql`
  mutation unlinkContactFromPerson($contact_id: ID!) {
    unlinkContactFromPerson(contact_id: $contact_id)
  }
`;

export const GetShoreAndWorkLocationTypes = gql`
  query getShoreAndWorkLocationTypes {
    getShoreAndWorkLocationTypes {
      shore_types {
        id
        name
      }
      work_location_types {
        id
        name
      }
    }
  }
`;

export const GetAllSkills = gql`
  query GetAllSkills {
    getSkills {
      id
      name
    }
  }
`;

export const SearchSkills = gql`
  query SearchSkills($query: String!, $selected_skills: [String!]) {
    searchSkills(query: $query, selected_skills: $selected_skills) {
      name
    }
  }
`;

export const SearchAddresses = gql`
  query SearchAddresses($query: String!, $country_code: String!) {
    searchAddresses(query: $query, country_code: $country_code) {
      suggestions {
        place_name
        street
        city
        state
        zipcode
        country
      }
    }
  }
`;

export const ParseResume = gql`
  mutation ParseResume($input: ResumeParseInput!) {
    parseResume(input: $input) {
      first_name
      last_name
      email
      phone
      linkedin
      summary
      skills
      address {
        street
        city
        state
        zip_code
        country
      }
      education {
        degree_name
        school_name
        start_date
        end_date
        gpa
      }
      experience {
        title
        company_name
        start_date
        end_date
        additional_information
      }
    }
  }
`;

export const GetCandidatePrescreens = gql`
  query getCandidatePrescreens($candidateId: ID!) {
    getCandidatePrescreens(candidateId: $candidateId) {
      id
      hirevue_position_id
      score
      linked_job_id
      job_title
      alternate_title
      hirevue_link
      client {
        id
        name
      }
    }
  }
`;

export const AddCandidatePrescreen = gql`
  mutation addCandidatePrescreen($input: AddCandidatePrescreenInput!) {
    addCandidatePrescreen(input: $input)
  }
`;

export const ManualScorePrescreen = gql`
  mutation manualScorePrescreen($input: ManualScorePrescreenInput!) {
    manualScorePrescreen(input: $input)
  }
`;
